import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getCities = async () => {
  const res = await request.get(
    '/Request/cities',
    {},
    '',
    [],
    undefined,
    'comma'
  );

  return res;
};

const useCities = ({ options }) =>
  useQuery(['cities'], () => getCities(), {
    ...options,
  });

export default useCities;
